function mean(values) {
  return values.length ? values.reduce((s, v) => s + v, 0) / values.length : null;
}

export function computeStats(trades = [], equity = [], openPosition = null) {
  const closed = trades.filter((t) => t.status === 'closed');
  const pnls = closed.map((t) => Number(t.pnl) || 0);
  const netPnl = pnls.reduce((s, v) => s + v, 0);
  const wins = closed.filter((t) => (Number(t.pnl) || 0) > 0);
  const losses = closed.filter((t) => (Number(t.pnl) || 0) < 0);
  const winPnls = wins.map((t) => Number(t.pnl) || 0);
  const lossPnls = losses.map((t) => Number(t.pnl) || 0);
  const grossWin = winPnls.reduce((s, v) => s + v, 0);
  const grossLoss = Math.abs(lossPnls.reduce((s, v) => s + v, 0));
  const rs = closed.map((t) => t.rMultiple).filter((v) => Number.isFinite(v));
  const winRs = wins.map((t) => t.rMultiple).filter((v) => Number.isFinite(v));
  const lossRs = losses.map((t) => t.rMultiple).filter((v) => Number.isFinite(v));
  const risks = [...trades, ...(openPosition ? [openPosition] : [])]
    .map((t) => Number(t.risk))
    .filter((v) => v > 0);

  let peak = 0;
  let maxDrawdown = 0;
  for (const pt of equity) {
    const eq = Number(pt.equity) || 0;
    if (eq > peak) peak = eq;
    const dd = peak - eq;
    if (dd > maxDrawdown) maxDrawdown = dd;
  }

  return {
    netPnl,
    tradeCount: closed.length,
    winRate: closed.length ? wins.length / closed.length : 0,
    profitFactor: grossLoss > 0 ? grossWin / grossLoss : (grossWin > 0 ? Infinity : 0),
    maxDrawdown,
    maxRisk: risks.length ? Math.max(...risks) : 0,
    avgR: mean(rs) ?? 0,
    avgWinR: mean(winRs),
    avgLossR: mean(lossRs),
    avgWin: winPnls.length ? grossWin / winPnls.length : 0,
    avgLoss: lossPnls.length ? -(grossLoss / lossPnls.length) : 0,
  };
}

export function buildEquity(trades = [], bars = []) {
  const byExit = new Map();
  for (const trade of trades) {
    if (trade.status !== 'closed' || trade.exitIndex == null) continue;
    byExit.set(trade.exitIndex, (byExit.get(trade.exitIndex) || 0) + (Number(trade.pnl) || 0));
  }
  let running = 0;
  const out = [];
  const n = bars.length || (byExit.size ? Math.max(...byExit.keys()) + 1 : 0);
  for (let i = 0; i < n; i++) {
    if (byExit.has(i)) running += byExit.get(i);
    const bar = bars[i];
    out.push({
      index: i,
      time: bar?.time ?? i,
      timeSec: bar?.timeSec,
      equity: running,
    });
  }
  return out;
}
